import {Button, IconButton} from "@mui/material";
import {useEffect} from "react";
import {FiPlus, FiTrash2} from "react-icons/fi";
import {useNavigate} from "react-router-dom";
import ListView from "../components/ListView/ListView";
import Window from "../components/Window/Window";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import {rolesColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import useConfirmDialog from "../hooks/useConfirmDialog";
import LoadingContent from "../components/ui/LoadingContent";
import {snackbar} from "../utils/snackbar";
import {useAuthPermissions, ACTIONS, RESOURCES} from "../hooks/useAuthPermissions";

const Roles = () => {
  const navigate = useNavigate();
  const {data, loading, list, remove} = useApiRequest({baseUrl: "/roles", resource: "roles"});
  const {can} = useAuthPermissions();

  // Hook para el diálogo de confirmación
  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async (id) => {
    const {success} = await remove(id);
    if (!success) return;

    snackbar.success("Rol eliminado correctamente.");
    await list();
  });

  useEffect(() => {
    list();
    // eslint-disable-next-line
  }, []);

  const handleRoleClick = (role) => {
    if (!role?.id) {
      snackbar.error("No se ha podido abrir el rol seleccionado.");
      return;
    }
    navigate(`/role-form`, {state: {id: role?.id}});
  };

  const handleOpenDeleteDialog = (id) => {
    const found = Array.isArray(data) ? data.find((role) => role.id === id) : null;
    openDialog(id, found?.name || "");
  };

  const columns = [
    ...rolesColumns,
    ...(can(ACTIONS.DELETE, RESOURCES.ROLES)
      ? [
          {
            field: "actions",
            headerName: "Actions",
            width: 150,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
              return (
                <IconButton
                  aria-label="delete"
                  color="error"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenDeleteDialog(params.row.id);
                  }}
                >
                  <FiTrash2 />
                </IconButton>
              );
            }
          }
        ]
      : [])
  ];

  return (
    <>
      <Window
        title={"Roles"}
        topRightButtons={
          can(ACTIONS.WRITE, RESOURCES.ROLES) && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<FiPlus />}
            onClick={() => {
              navigate(`/role-form`);
            }}
          >
            Nuevo Rol
          </Button>
          )
        }
      >
        {loading ? (
          <LoadingContent />
        ) : (
          <ListView columns={columns} data={data} loading={loading} onRowClick={handleRoleClick} />
        )}
      </Window>

      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="rol"
        entityLabel={itemName}
      />
    </>
  );
};

export default Roles;
